var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#marker_svg__filter0_d_10319_60504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.602 28c0 8.011-5.938 14.728-13.931 16.527-1.375.31-2.81 5.473-4.287 5.473-1.476 0-2.912-5.164-4.286-5.473-7.993-1.8-13.932-8.516-13.932-16.527 0-9.389 8.157-17 18.218-17 10.062 0 18.218 7.611 18.218 17z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "marker_svg__filter0_d_10319_60504",
    x: 0.166,
    y: 0,
    width: 66.436,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.768924 0 0 0 0 0.804634 0 0 0 0 0.895833 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10319_60504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10319_60504",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/marker.ea22015d.svg";
export { SvgMarker as ReactComponent };